import {SiteFormDefaultValues, SiteFormProps, SiteFormRawValues, SiteFormType, SiteFormValues} from "./SiteForm";
import {useTranslation} from "react-i18next";
import {useForm} from "@mantine/form";
import {getObjectId, SiteEntity} from "@ots-frontend/ots-data";
import {validateLatCoord, validateLongCoord} from "../form-utils";

export const toFormDefaultsFromSite = (site: SiteEntity | undefined): Partial<SiteFormValues> => {
  return {
    name: site?.name,
    leaseId: site?.leaseId,
    leaseName: site?.leaseName,
    type: site?.type,
    freightType: site?.freightTypeId,
    operator: site?.companyId,
    owner: site?.ownerId,
    operatingArea: site?.operatingAreaId,
    companyUnit: site?.companyUnitId,
    parentSite: site?.parentSiteId,
    geofenceSiteGroup: site?.geofenceSiteGroupId,
    afe: site?.afe,
    afePrefix: site?.afePrefix,
    afeSuffix: site?.afeSuffix,
    address: {
      street: site?.address?.street,
      street2: site?.address?.street2,
      city: site?.address?.city,
      county: site?.address?.county,
      country: site?.address?.country,
      postalCode: site?.address?.postalCode,
      province: site?.address?.province,
    },
    latCoord: site?.latCoord,
    longCoord: site?.longCoord,
    transportViaPipeline: site?.transportViaPipeline,
    transportOilViaPipeline: site?.transportOilViaPipeline,
    doNotUse: site?.doNotUse,
  };
};

const getInitialValues = (defaultValues: SiteFormDefaultValues | undefined): SiteFormRawValues => {
  return {
    name: defaultValues?.name,
    leaseId: defaultValues?.leaseId,
    leaseName: defaultValues?.leaseName,
    type: defaultValues?.type?.code,
    freightType: getObjectId(defaultValues?.freightType),
    operator: getObjectId(defaultValues?.operator),
    owner: getObjectId(defaultValues?.owner),
    operatingArea: getObjectId(defaultValues?.operatingArea),
    companyUnit: getObjectId(defaultValues?.companyUnit),
    parentSite: getObjectId(defaultValues?.parentSite),
    geofenceSiteGroup: getObjectId(defaultValues?.geofenceSiteGroup),
    afe: defaultValues?.afe,
    afePrefix: defaultValues?.afePrefix,
    afeSuffix: defaultValues?.afeSuffix,
    address: defaultValues?.address,
    latCoord: defaultValues?.latCoord,
    longCoord: defaultValues?.longCoord,
    transportViaPipeline: defaultValues?.transportViaPipeline,
    transportOilViaPipeline: defaultValues?.transportOilViaPipeline,
    doNotUse: defaultValues?.doNotUse,
  }
}

export type UseSiteFormProps = Pick<SiteFormProps, 'defaultValues'> & {}

export function useSiteForm(props: UseSiteFormProps): SiteFormType {
  const {
    defaultValues
  } = props

  const {t} = useTranslation(["common"])

  const form = useForm({
    initialValues: getInitialValues({
      ...defaultValues,
    }),
    validate: {
      name: (value) => value ? undefined : t("common.validation.required", "Required"),
      operator: (value) => value ? undefined : t("common.validation.required", "Required"),
      latCoord: (value) => validateLatCoord(value, false, t),
      longCoord: (value) => validateLongCoord(value, false, t),
    },
  })

  return form
}
